<template>
  <form @submit.prevent="submit">
    <div class="content">
      <p>
        <strong>Welcome – you're in safe hands.</strong>
      </p>
      <p>
        fixed.net has partnered with Google to help website owners quickly
        recover from malware and other issues affecting their site and ads. Your
        unique code below entitles you to a
        <strong>free one-time cleanup task</strong> – no payment details
        required. Our team of experts will take it from there.
      </p>
      <p>Just confirm your code and website below to get started.</p>
    </div>

    <site-url-field
      :url="form.siteUrl ? form.siteUrl.url : payload.sitePrefill"
      :disabled="processing"
      required
      @change="form.siteUrl = $event"
    />

    <b-field label="Coupon code *">
      <b-input
        v-model="form.couponId"
        :disabled="processing"
        placeholder="Your unique coupon code"
        required
      />
    </b-field>

    <step-controls
      :back="false"
      :enabled="formIsValid"
      :processing="processing"
    />
  </form>
</template>

<script>
export default {
  name: "GoogleCleanupIntroStep",
  components: {
    "site-url-field": () => import("@shared/sites/_siteUrlField")
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      processing: false,
      form: {
        couponId: this.payload.couponId || "",
        siteUrl: this.payload.siteUrl || null
      }
    };
  },
  computed: {
    formIsValid() {
      if (!this.$_.trim(this.form.couponId)) return false;
      if (this.$_.isEmpty(this.form.siteUrl)) return false;
      return true;
    }
  },
  methods: {
    async submit() {
      if (!this.formIsValid || this.processing) return;
      this.processing = true;
      const couponId = this.$_.trim(this.form.couponId);
      const { isValid, description } = await this.$store.dispatch(
        "promotion/validateCoupon",
        { couponId }
      );
      this.processing = false;
      if (!isValid) {
        this.$modal.open({
          component: () => import("@shared/ui/_noticeModal"),
          parent: this,
          width: 500,
          hasModalCard: true,
          props: {
            title: "Coupon invalid",
            message:
              "Sorry, it looks like that code isn't valid, has expired, or " +
              "has already been used. Please double-check the link you were " +
              "given – or if you think something's wrong, get in touch with " +
              "our team and we'll be happy to help."
          }
        });
        return;
      }
      this.$emit("payload", {
        couponId,
        siteUrl: this.form.siteUrl,
        promotionDescription: description
      });
      this.$emit("next");
    }
  }
};
</script>
